import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Popup from "./Popup";
import {useOpenPopup} from "../context/contextHooks";

const DocLink = (props) => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(true);
    const [done, setDone] = useState(false);
    const [, setOpenPopup] = useOpenPopup();
    const component=props.component;
    const title=props.title;

    useEffect(() => {
        if (done) {
            setOpen(false);
            setOpenPopup(false);
            navigate(-1);
        }
    }, [done])

    return (
        <>
            <Popup open={open} setDone={setDone} title={title} component={component} />
        </>
    );
}

export default DocLink;
